<script lang="ts"> 
    // import ShoppableUnitCard from "@shared/svelte/Components/ShoppableUnit/ShoppableUnitCard.svelte";

    import { isEmpty } from "lodash";
    import ShoppableUnitCard from "@shared/svelte/Components/ShoppableUnit/ShoppableUnitCard.svelte";
    import CardCarousel from "@shared/svelte/Components/Carousel/CardCarousel.svelte";
    import LayoutStore from "@shared/svelte/Stores/LayoutStore";
    import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
    import { KevelShoppableUnitAdEntity } from "@shared/services/event_tracking/entities/ads/kevel_shoppable_unit_ad_entity";

    export let shoppableUnit: any;
    export let shouldFetchData: boolean = false;
    export let pageName: string | null = null;
    export let mobileMode: boolean = false;

    shoppableUnit; shouldFetchData; pageName; mobileMode;

    $: windowWidth = 0; 

    let logoProps = { alt: shoppableUnit.tag_line, src: `https://static.adzerk.net/Advertisers/${shoppableUnit.brand_logo}` };
    let imageProps = { alt: shoppableUnit.tag_line, src: `https://static.adzerk.net/Advertisers/${shoppableUnit.hero_image}` };

    const trackingParams = () => {
      const shoppableUnitAdEntityParams: KevelShoppableUnitAdEntity =
        new KevelShoppableUnitAdEntity({
          object_tracking_id: shoppableUnit.object_tracking_id,
          ad_id: shoppableUnit.ad_id,
          advertiser_id: shoppableUnit.advertiser_id,
          placement_name: shoppableUnit.placement_name,
          flight_id: shoppableUnit.flight_id,
          campaign_id: shoppableUnit.campaign_id,
          priority_id: shoppableUnit.priority_id,
          creative_id: shoppableUnit.creative_id,
          events: shoppableUnit.events,
          forward_url: shoppableUnit.forward_url,
        });
  
      return [shoppableUnitAdEntityParams];
    };
</script>
  
<svelte:window bind:innerWidth={windowWidth} />

{#if !isEmpty(shoppableUnit)}
<TrackingContext entities={trackingParams()}>
  <section class="fizz-surface-blue" data-testid="shoppable-unit">
    <div class="fizz-inset-square-32 fizz-container">
      {#if $LayoutStore.isMobile && windowWidth < 700}
        <div class="fizz-stack-16">
            <ShoppableUnitCard
            sponsoredFlag
            tagLine={shoppableUnit.tag_line}
            forwardLink={shoppableUnit.forward_url}
            logoProps={ logoProps }
            imageProps={ imageProps }
            />
        </div>
        <CardCarousel
            productLines={shoppableUnit.product_lines}
            carouselIdentifier={"shoppable_unit"}
            showTitle={false}
            carouselName={"shoppable_unit"}
        />
        {:else if windowWidth >= 700}
        <CardCarousel
            productLines={shoppableUnit.product_lines}
            carouselIdentifier={"shoppable_unit"}
            showTitle={false}
            shoppableUnit
            carouselName={"shoppable_unit"}
        >
            <ShoppableUnitCard
            slot="shoppable-unit"
            sponsoredFlag
            tagLine={shoppableUnit.tag_line}
            forwardLink={shoppableUnit.forward_url}
            logoProps={ logoProps }
            imageProps={ imageProps }
            />
        </CardCarousel>
        {/if}
    </div>
  </section>
</TrackingContext>
{/if}
